import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsOpportunityObjectBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The opportunity object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the opportunity.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'Whether the opportunity is closed.',
                heading: 'closed',
                subheading: 'boolean',
              },
              {
                description: 'The name of the opportunity.',
                heading: 'name',
                subheading: 'string',
              },
              {
                description: 'The list of post ids this opportunity is linked to.',
                heading: 'postIDs',
                subheading: 'array',
              },
              {
                description: 'The unique identifier for the opportunity in Salesforce.',
                heading: (
                  <p>
                    salesforce
                    <wbr />
                    OpportunityID
                  </p>
                ),
                subheading: 'string',
              },
              {
                description: 'The value of the opportunity.',
                heading: 'value',
                subheading: 'number',
              },
              {
                description: 'Whether the opportunity has been won.',
                heading: 'won',
                subheading: 'boolean',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example opportunity object:</div>
          <Highlight lang="json">
            {`{
  "id": "61a942ed07bfe27b60109ee0",
  "closed": true,
  "name": "Opportunity Name",
  "postIDs": ["61a942ed07bfe27b60109eaf", "61a942ed07bfe27b60109ebc"],
  "salesforceOpportunityID": "0063k00000zx6BkAAI",
  "value": 1999.99,
  "won": true
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
